import { defineStore } from "pinia";
import { ref } from "vue";
import useMyFetch from "@stores/useMyFetch";

export const useCardTypesStore = defineStore("cardTypes", () => {
  const creatableTypes = ref(new Set());

  async function fetch(token) {
    const { data } = await useMyFetch(`/card_types?survey_token=${token}`).json();
    creatableTypes.value = new Set((data.value ?? []).filter(({ creatable }) => creatable).map(({ type }) => type));
  }

  return { creatableTypes, fetch };
});
